import { ProductKeys, product } from '@/data/productsConfig';

type ProductTermLinks = {
  [key in ProductKeys]?: { key: string; url: string };
};

const pedalPromoLink = {
  key: 'pedal-promo-terms',
  url: '/pedal-promo-terms',
};
const powerPromoLink = {
  key: 'power-promo-terms',
  url: '/power-promo-terms',
};

const productTermsLinks: ProductTermLinks = {
  [product.original]: pedalPromoLink,
  [product.originalPlus]: pedalPromoLink,
  [product.deluxe7]: pedalPromoLink,
  [product.power1]: powerPromoLink,
  [product.power7]: powerPromoLink,
};

export const getSpecialOfferTermsLink = (key: ProductKeys) =>
  productTermsLinks[key]!;
